import React, { useEffect } from 'react';
import { Routes } from 'react-router-dom';
import { Route, useMatch } from 'react-router';
import FileExplorerPage from 'documents/containers/FileExplorerPage';
import SpaceMembersPage from 'contacts/containers/SpaceMembersPage/SpaceMembersPage';
import { getAuthUserId, getIsAdmin } from 'auth/store/auth/selectors';
import { fetchAllSpaceRoles } from 'auth/store/roles/actions';
import { fetchAuditPendingRoleIdsForSpaceId } from 'auth/store/audit/actions';
import TrashPage from 'trash/containers/TrashPage/TrashPage';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import usePrevious from 'hooks/usePrevious';
import Loader from 'base/components/Loader';
import SpacePermissionsEntry from './SpacePermissionsEntry';
import SpacePermissions from './SpacePermissions/SpacePermissions';
import { getActiveSpace } from '../store/selectors';
import { setActiveSpaceId } from '../store/actions';

export default function SpaceRoutes() {
  const dispatch = useAppDispatch();
  const space = useAppSelector(getActiveSpace);
  const isAdmin = useAppSelector(getIsAdmin);
  const myUserId = useAppSelector(getAuthUserId);
  const isSpaceOwner = space && space.owner && space.owner === myUserId;
  const match = useMatch('/spaces/:spaceId/*');
  const spaceId = match?.params?.spaceId || '';
  const prevSpaceId = usePrevious(spaceId);

  useEffect(() => {
    dispatch(setActiveSpaceId(spaceId));
  }, [dispatch, spaceId]);

  useEffect(() => {
    const spaceChanged = spaceId !== prevSpaceId;
    if (spaceChanged) {
      dispatch(setActiveSpaceId(spaceId));
      if (isAdmin || isSpaceOwner) {
        dispatch(fetchAllSpaceRoles(spaceId));
        dispatch(fetchAuditPendingRoleIdsForSpaceId(spaceId));
      }
    }
  }, [spaceId, prevSpaceId, dispatch, isAdmin, isSpaceOwner]);

  return (
    <Loader isLoading={!space}>
      <Routes>
        <Route path="/:spaceId/documents/folder/:folderId/document/:documentId" element={<FileExplorerPage />} />
        <Route path="/:spaceId/documents/folder/:folderId" element={<FileExplorerPage />} />
        <Route path="/:spaceId/documents/document/:documentId" element={<FileExplorerPage />} />
        <Route path="/:spaceId/members" element={<SpaceMembersPage />} />
        <Route path="/:spaceId/permissions/:roleId" element={<SpacePermissions />} />
        <Route path="/:spaceId/permissions" element={<SpacePermissionsEntry />} />
        <Route path="/:spaceId/trash" element={<TrashPage />} />
        <Route path="/:spaceId/documents" element={<FileExplorerPage />} />
        <Route path="/:spaceId" element={<FileExplorerPage />} />
      </Routes>
    </Loader>
  );
}
